import { render, staticRenderFns } from "./DashboardRex.vue?vue&type=template&id=574e33b4&"
import script from "./DashboardRex.vue?vue&type=script&lang=js&"
export * from "./DashboardRex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports